import React from 'react'
import InputButton from "../InputButton";
import StarRatings from "react-star-ratings";
import Comment from "../Comment";
import { useTranslation } from "react-i18next";

const RatingForm= (props) => {
   const { t } = useTranslation();
   return (
        <>
            <form onSubmit={props.onSubmitForm}>
                <div>
                    <span>{t("rating")}</span>
                    <StarRatings
                        changeRating={props.changeRating}
                        rating={props.call_rating}
                        starRatedColor='rgb(255, 230, 16)'
                        starHoverColor='rgb(165, 204, 82)'
                        starDimension='25px'
                        starSpacing={'5px'}
                        numberOfStars={5}
                        name='call_rating'
                    />
                </div>
                <Comment
                    background_exist={props.background_exist}
                    commentHandler={props.commentHandler}
                    comment={props.user_comment}
                />
                <InputButton text={t("send")}/>
            </form>
        </>
    )
}
export default RatingForm